import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getAttribution } from "../utils/attribution";

const API = process.env.REACT_APP_API_URL || "https://security-xi-rust.vercel.app";

function getDeviceType() {
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk/i.test(ua)) return "tablet";
  if (/mobile|iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(ua)) return "mobile";
  return "desktop";
}

function getBrowserName() {
  const ua = navigator.userAgent;
  if (ua.includes("Edg")) return "Edge";
  if (ua.includes("OPR") || ua.includes("Opera")) return "Opera";
  if (ua.includes("Chrome")) return "Chrome";
  if (ua.includes("Firefox")) return "Firefox";
  if (ua.includes("Safari")) return "Safari";
  return "Other";
}

function getSessionId() {
  let sid = sessionStorage.getItem("analytics_session_id");
  if (!sid) {
    sid = Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
    sessionStorage.setItem("analytics_session_id", sid);
  }
  return sid;
}

/**
 * Campaign attribution for this event. It is captured on arrival by
 * src/utils/attribution.js (sessionStorage "lead_attribution"), so it is still
 * known when cookie consent is given after the landing page.
 * visitor_events has one click-id column: gclid, else gbraid, else wbraid.
 */
function pageViewAttribution() {
  const a = getAttribution();
  return {
    gclid: a.gclid || a.gbraid || a.wbraid || null,
    utm_source: a.utm_source,
    utm_medium: a.utm_medium,
    utm_campaign: a.utm_campaign,
    utm_term: a.utm_term,
    utm_content: a.utm_content,
  };
}

/**
 * Fires a 'page_view' analytics event on every route change,
 * but only when the visitor has previously accepted cookies.
 */
export default function usePageView() {
  const location = useLocation();

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (consent !== "true") return;

    const lang = localStorage.getItem("preferredLang") || "en";

    let region = null;
    try {
      const geo = JSON.parse(sessionStorage.getItem("visitor_geo") || "null");
      if (geo) region = [geo.city, geo.region, geo.country].filter(Boolean).join(", ");
    } catch {}

    const attribution = pageViewAttribution();

    fetch(`${API}/api/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event_type: "page_view",
        page: location.pathname,
        referrer: document.referrer || null,
        lang,
        device_type: getDeviceType(),
        browser: getBrowserName(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        region: region || null,
        session_id: getSessionId(),
        ...attribution,
      }),
    }).catch(() => {});
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps
}
